import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Security, LoginCallback } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";

import "./styles.css";
import Home from "./pages/Home";
import Metrics from "./pages/Metrics";
import { ISSUER, CLIENT_ID, SCOPES, STATE } from "./config/okta";

export default function App () {

  // Okta authentication
  const oktaAuth = new OktaAuth({
    issuer: ISSUER,
    clientId: CLIENT_ID,
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: SCOPES,
    state: STATE,
  });

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    window.location.replace(
      toRelativeUrl(originalUri, window.location.origin),
    );
  };

  return (
    <BrowserRouter>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <Routes>
          <Route path="/:leadId" element={<Home />}>
            <Route path=":leadId" element={<Home />} />
          </Route>
          <Route path="/metrics" element={<Metrics />} />
          <Route path="/login/callback" element={<LoginCallback />} />
        </Routes>
      </Security>
    </BrowserRouter>
  );
}
